<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon icon="FileIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="openReport(params.DocName, params.CollectionName)" />
    </div>
</template>

<script>
export default {
  name: 'CellRendererActionsReport',
  methods: {
    openReport (DocName, CollectionName) {
      this.$vs.loading();
      this.$store.dispatch("mailtplManagement/fetchdeliveryReport", {DocName: DocName, CollectionName: CollectionName, Subject: null}).then(res => {  
        this.$vs.loading.close();
        if(res.data)
          this.$root.$emit("openReportPopUp", {data: res.data.result.messages, DocName: DocName, CollectionName: CollectionName});
      })
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${this.params.data.username}"`,
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    deleteRecord () {
      /* Below two lines are just for demo purpose */
      this.showDeleteSuccess()

      /* UnComment below lines for enabling true flow if deleting user */
      // this.$store.dispatch("userManagement/removeRecord", this.params.data.id)
      //   .then(()   => { this.showDeleteSuccess() })
      //   .catch(err => { console.error(err)       })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'User Deleted',
        text: 'The selected user was successfully deleted'
      })
    }
  }
}
</script>
